import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=6c850350&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=js&"
export * from "./DownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c850350",
  null
  
)

export default component.exports